import classNames from 'classnames';
import { FC, useCallback, useMemo } from 'react';

import { handleKeyboardSelect } from '../../helpers/Accessibility';
import styles from './NoSlotButton.module.scss';

interface NoSlotButtonProps {
  className?: string;
  disabled?: boolean;
  onSelect: (selected: boolean) => void;
  selected?: boolean;
  text: string;
}

export const NoSlotButton: FC<NoSlotButtonProps> = ({ text, disabled, onSelect, selected }) => {

  const handleSelect = useCallback(() => {
    if (!disabled) {
      onSelect(!selected);
    }
  }, [onSelect, disabled, selected]);

  const handleKeyDown = useMemo(() => handleKeyboardSelect(handleSelect), [handleSelect]);

  return (
    <div className={styles.buttonWrapper}>
      <button
        aria-current={selected}
        className={classNames(
          styles.slot,
          selected && 'partner-initial-border-color-rounded',
          disabled && styles.disabled
        )}
        disabled={disabled}
        onClick={handleSelect}
        onKeyDown={handleKeyDown}
        tabIndex={0}
      >
        <div className={classNames(styles.slotWrapper)}>
          <div className={styles.slotInfo}>
            <div className={classNames(
              styles.slotText,
              selected && styles.selected)}>{text}</div>
          </div>
        </div>
      </button>
    </div>
  );
};
